import Vue from 'vue';
import VueI18n, { LocaleMessages, NumberFormats } from 'vue-i18n';
import getBrowserLocale from '@/utils/i18n-helpers';

Vue.use(VueI18n);

const numberFormats: NumberFormats = {
	'en-CA': {
		currency: {
			style: 'currency',
			currency: 'CAD'
		}
	},
	'fr-CA': {
		currency: {
			style: 'currency',
			currency: 'CAD'
		}
	}
};

function loadLocaleMessages (): LocaleMessages {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
	const messages: LocaleMessages = {};
	locales.keys().forEach((key: string) => {
		// Match pattern like "./en-CA/auth.json" or "./fr-CA/menus.json"
		const matched = key.match(/\.\/([A-Za-z0-9-_]+)\/([A-Za-z0-9-_]+)\.json$/i);
		if (matched && matched.length > 2) {
			const locale = matched[1]; // e.g., "en-CA"
			const namespace = matched[2]; // e.g., "auth"

			if (!messages[locale]) {
				messages[locale] = {};
			}

			messages[locale][namespace] = locales(key);
		}
	});
	return messages;
}

export default new VueI18n({
	locale: getBrowserLocale(),
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-CA',
	messages: loadLocaleMessages(),
	numberFormats
});
